export const ITEM_GROUP_DOCUMENT_DROP_DOWN_ITEMS = []